import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'FooterTwo',
  templateUrl: './FooterTwo.component.html',
  styleUrls: ['./FooterTwo.component.scss'],
  changeDetection:ChangeDetectionStrategy.OnPush
})
export class FooterTwoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
